/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="83.39"
        height="65.09"
        viewBox="0 0 83.39 65.09"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M117.64,45H36.75a1.25,1.25,0,0,0-1.25,1.25v62.59a1.25,1.25,0,0,0,1.25,1.25h80.89a1.25,1.25,0,0,0,1.25-1.25V46.25A1.25,1.25,0,0,0,117.64,45Zm-1.25,2.5v60.08H38V47.5Z"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M45.61,52.86a1.48,1.48,0,1,1-1.48-1.48,1.48,1.48,0,0,1,1.48,1.48"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-base"
          fillRule="evenodd"/><path
          d="M53.19,52.86a1.48,1.48,0,1,1-1.47-1.48,1.48,1.48,0,0,1,1.47,1.48"
          transform="translate(-35.5 -45)"
          fill="#0e497b"
          className="icon-fill icon-base"
          fillRule="evenodd"/><path
          fill="#0e497b"
          d="M60.78,52.86a1.48,1.48,0,1,1-1.48-1.48,1.48,1.48,0,0,1,1.48,1.48"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-base"
          fillRule="evenodd"/><path
          fill="#0e497b"
          d="M105.82,72a1,1,0,0,1,.11,2H77.06a1,1,0,0,1-.12-2h28.88Z"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M105.82,82a1,1,0,0,1,.11,2H69.75a1,1,0,0,1-.11-2h36.18Z"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M105.57,91.93a1,1,0,0,1,.11,2H69.5a1,1,0,0,1-.11-2h36.18Z"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M52.9,69.85v2.29l-.35.07-.36.07a5.49,5.49,0,0,0-4.14,3.36,6.72,6.72,0,0,0-.48,3.13,5.36,5.36,0,0,0,2.88,4.58,22.68,22.68,0,0,0,2.41,1.08c1,.42,2,.81,3,1.24a1.84,1.84,0,0,1,1.14,2,2,2,0,0,1-1.61,2,6,6,0,0,1-1.27.14,3.16,3.16,0,0,1-3.23-2.36c-.1-.28-.17-.57-.25-.88l-3.84,1a7.89,7.89,0,0,0,1.85,3.8,6.48,6.48,0,0,0,4.22,1.95v3h2.48v-3c.5-.1,1-.17,1.46-.3a5.73,5.73,0,0,0,4-3.28,6.74,6.74,0,0,0,.46-4,5.29,5.29,0,0,0-2.69-3.81A28.67,28.67,0,0,0,55,80.33c-.75-.3-1.48-.65-2.21-1a1.61,1.61,0,0,1-.83-1,2.24,2.24,0,0,1,1.57-2.82,2.61,2.61,0,0,1,2.57.67,4.91,4.91,0,0,1,1,1.58l.25.58,3.44-1.42a6.93,6.93,0,0,0-1.26-2.59,6.07,6.07,0,0,0-4.18-2.18V69.85Z"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><path
          fill="#0e497b"
          d="M117.64,58.67a1,1,0,0,1,.12,2h-81a1,1,0,0,1-.12-2h81Z"
          transform="translate(-35.5 -45)"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'WebPageWithDollarSignIcon';

export default Icon;
